//https://stackoverflow.com/questions/41742390/javascript-to-check-if-pwa-or-mobile-web
export const isInStandaloneMode = () => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any)?.electron ||
    window?.matchMedia("(display-mode: standalone)")?.matches ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window?.navigator?.["standalone"] ||
    document?.referrer?.includes("android-app://") ||
    "ReactNativeWebView" in window
  );
};
